<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Transplant Details EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="transplantType"
              disabled
              label="Transplant Type"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartDate"
              disabled
              label="Transplant Start Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="transplantStartTime"
              disabled
              label="Transplant Start Time"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="transplantDate"
              disabled
              label="Transplant Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
            <ADSTextInput
              v-model="transplantColdDateLeftKidney"
              disabled
              label="Removed from Cold Date - Left Kidney"
            />
          </div>

          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="transplantColdDateLeftKidney"
              disabled
              label="Removed from Cold Date"
            />
          </div>

          <div class="col-3" v-if="organ === 'Kidney' && ( transplantColdDateRightKidney === null || transplantColdDateRightKidney === undefined || transplantColdDateRightKidney === '' )">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidney"
              disabled
              label="Removed from Cold Time - Left Kidney"
            />
          </div>

          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="transplantColdTimeLeftKidney"
              disabled
              label="Removed from Cold Time"
            />
          </div>


          <div
            v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )"
            class="col-3">
            <ADSTextInput
              v-model="transplantColdDateRightKidney"
              disabled
              label="Removed from Cold Date - Right Kidney"
            />
          </div>

          <div
            v-if="organ === 'Kidney' && ( transplantColdDateLeftKidney === null || transplantColdDateLeftKidney === undefined || transplantColdDateLeftKidney === '' )"
            class="col-2">
            <ADSTextInput
              v-model="transplantColdTimeRightKidney"
              disabled
              label="Removed from Cold Time - Right Kidney"
            />
          </div>
        </div>

        <div class="row">
          <div v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateLeftKidney"
              disabled
              label="Clamp Removal Date - Left Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateRightKidney === null || clampRemovalDateRightKidney === undefined || clampRemovalDateRightKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeLeftKidney"
              disabled
              label="Clamp Removal Time - Left Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalDateRightKidney"
              disabled
              label="Clamp Removal Date - Right Kidney"
            />
          </div>
          <div v-if="organ === 'Kidney' && ( clampRemovalDateLeftKidney === null || clampRemovalDateLeftKidney === undefined || clampRemovalDateLeftKidney === '' )" 
          class="col-3">
            <ADSTextInput
              v-model="clampRemovalTimeRightKidney"
              disabled
              label="Clamp Removal Time - Right Kidney"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampDate"
              disabled
              label="Portal Vein Cross Clamp Date"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinCrossClampTime"
              disabled
              label="Portal Vein Cross Clamp Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="perfusionPumpDate"
              disabled
              label="Normothermic Perfusion Pump Removal Date"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="perfusionPumpTime"
              disabled
              label="Normothermic Perfusion Pump Removal Time"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalDate"
              disabled
              label="Portal Vein Clamp Removal Date"
            />
          </div>
          <div v-if="organ === 'Liver'" class="col-3">
            <ADSTextInput
              v-model="portalVeinClampRemovalTime"
              disabled
              label="Portal Vein Clamp Removal Time"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="vesselUsed"
              disabled
              label="Vessel Used"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalDate"
              disabled
              label="Hepatic Artery Clamp Removal Date"
            />
          </div>
          <div class="col-3" v-if="organ === 'Liver'">
            <ADSTextInput
              v-model="hepaticArteryClampRemovalTime"
              disabled
              label="Hepatic Artery Clamp Removal Time"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "TransplantSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      transplantType: this.getTransplantType( this.patientBundle ),
      transplantStartDate: this.getTransplantStartDate( this.patientBundle ),
      transplantStartTime: this.getTransplantStartTime( this.patientBundle )?.substring( 0, 5 ),
      transplantDate: this.getTransplantDate( this.patientBundle ),
      transplantColdDateLeftKidney: this.getTransplantColdDateLeftKidney( this.patientBundle ),
      transplantColdTimeLeftKidney: this.getTransplantColdTimeLeftKidney( this.patientBundle )?.substring( 0, 5 ),
      transplantColdDateRightKidney: this.getTransplantColdDateRightKidney( this.patientBundle ),
      transplantColdTimeRightKidney: this.getTransplantColdTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateLeftKidney: this.getClampRemovalDateLeftKidney( this.patientBundle ),
      clampRemovalTimeLeftKidney: this.getClampRemovalTimeLeftKidney( this.patientBundle )?.substring( 0, 5 ),
      clampRemovalDateRightKidney: this.getClampRemovalDateRightKidney( this.patientBundle ),
      clampRemovalTimeRightKidney: this.getClampRemovalTimeRightKidney( this.patientBundle )?.substring( 0, 5 ),
      vesselUsed: this.getVesselUsed( this.patientBundle ),
      portalVeinCrossClampDate: this.getPortalVeinCrossClampDate( this.patientBundle ),
      portalVeinCrossClampTime: this.getPortalVeinCrossClampTime( this.patientBundle )?.substring( 0, 5 ),
      perfusionPumpDate: this.getPerfusionPumpDate( this.patientBundle ),
      perfusionPumpTime: this.getPerfusionPumpTime( this.patientBundle )?.substring( 0, 5 ),
      portalVeinClampRemovalDate: this.getPortalVeinClampRemovalDate( this.patientBundle ),
      portalVeinClampRemovalTime: this.getPortalVeinClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
      hepaticArteryClampRemovalDate: this.getHepaticArteryClampRemovalDate( this.patientBundle ),
      hepaticArteryClampRemovalTime: this.getHepaticArteryClampRemovalTime( this.patientBundle )?.substring( 0, 5 ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getRemovedFromColdDateLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Date - Left Kidney' : 'Removed from Cold Date';
    },
    getRemovedFromColdTimeLabel() {
      return this.organ === 'Kidney' ? 'Removed from Cold Time - Left Kidney' : 'Removed from Cold Time';
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
      _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getTransplantType( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4013' );
    },
    getTransplantStartDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4014', 'valueDateTime' );
    },
    getTransplantStartTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4016', 'valueTime' );
    },
    getTransplantDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4011', 'valueDateTime' );
    },
    getTransplantColdDateLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4017', 'valueDateTime' );
    },
    getTransplantColdTimeLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4018', 'valueTime' );
    },
    getTransplantColdDateRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4019', 'valueDateTime' );
    },
    getTransplantColdTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4020', 'valueTime' );
    },
    getClampRemovalDateLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4021', 'valueDateTime' );
    },
    getClampRemovalTimeLeftKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4022', 'valueTime' );
    },
    getClampRemovalDateRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4023', 'valueDateTime' );
    },
    getClampRemovalTimeRightKidney( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4024', 'valueTime' );
    },
    getVesselUsed( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4083', 'valueBoolean' );
    },
    getPortalVeinCrossClampDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4080', 'valueDateTime' );
    },
    getPortalVeinCrossClampTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4081', 'valueTime' );
    },
    getPerfusionPumpDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4084', 'valueDateTime' );
    },
    getPerfusionPumpTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4085', 'valueTime' );
    },
    getPortalVeinClampRemovalDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4086', 'valueDateTime' );
    },
    getPortalVeinClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4087', 'valueTime' );
    },
    getHepaticArteryClampRemovalDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4088', 'valueDateTime' );
    },
    getHepaticArteryClampRemovalTime( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'UHN#4089', 'valueTime' );
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 660px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
